import { TrendingUp, Sparkles, Phone, X, Building, Star } from "lucide-react";

export default function StatsCards({ stats, loading, activeFilter, onFilterClick }) {
  if (loading || !stats) {
    return (
      <div data-testid="stats-cards" className="grid grid-cols-2 lg:grid-cols-5 gap-3">
        {[1, 2, 3, 4, 5].map(i => (
          <div key={i} className="border border-zinc-200 rounded-sm p-4 animate-pulse">
            <div className="h-3 bg-zinc-100 rounded w-20 mb-3" />
            <div className="h-8 bg-zinc-100 rounded w-16" />
          </div>
        ))}
      </div>
    );
  }

  const cards = [
    {
      label: "Totale",
      value: stats.total,
      icon: Building,
      color: "text-zinc-900",
      bg: "bg-white",
      filterKey: null,
    },
    {
      label: "Nuovi",
      value: stats.new,
      icon: Sparkles,
      color: "text-emerald-700",
      bg: "bg-emerald-50",
      borderColor: "border-emerald-200",
      filterKey: "new",
    },
    {
      label: "Interessanti",
      value: stats.interesting,
      icon: TrendingUp,
      color: "text-blue-700",
      bg: "bg-blue-50",
      borderColor: "border-blue-200",
      filterKey: "interesting",
    },
    {
      label: "Contattati",
      value: stats.contacted,
      icon: Phone,
      color: "text-amber-700",
      bg: "bg-amber-50",
      borderColor: "border-amber-200",
      filterKey: "contacted",
    },
    {
      label: "Acquisiti",
      value: stats.acquired ?? 0,
      icon: Star,
      color: "text-yellow-700",
      bg: "bg-yellow-50",
      borderColor: "border-yellow-200",
      filterKey: "acquired",
    },
  ];

  return (
    <div data-testid="stats-cards" className="grid grid-cols-2 lg:grid-cols-5 gap-3">
      {cards.map((card) => {
        const Icon = card.icon;
        const isActive = activeFilter === card.filterKey && card.filterKey;
        return (
          <div
            key={card.label}
            data-testid={`stat-${card.label.toLowerCase()}`}
            onClick={() => onFilterClick?.(card.filterKey === activeFilter ? null : card.filterKey)}
            className={`${card.bg} border ${isActive ? "border-zinc-900 ring-2 ring-zinc-900/10" : card.borderColor || "border-zinc-200"} rounded-sm p-4 transition-all duration-200 hover:shadow-sm ${card.filterKey ? "cursor-pointer" : ""}`}
          >
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs tracking-wider uppercase font-semibold text-zinc-500">
                {card.label}
              </span>
              <Icon className={`w-3.5 h-3.5 ${card.color}`} />
            </div>
            <div className={`text-3xl font-black tabular-nums ${card.color}`}>
              {card.value}
            </div>
          </div>
        );
      })}
    </div>
  );
}
